<template>
  <div class="modal fade" id="baby_name_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel">Update Baby Name: {{baby.name}}</h4>
        </div>
        <form method="post" @submit.prevent="updateBabyDetails()">
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Name</label>
              <input v-model="baby.name" type="text" readonly class="form-control" id="babyName" placeholder="Name...">
            </div>
            <div class="form-group">
              <label >Urdu</label>
              <input v-model="baby.urduName" type="text" readonly class="form-control">
            </div>
            <div class="form-group">
              <label >Gender</label>
              <input v-model="gender" type="text" readonly class="form-control" placeholder="gender...">
            </div>
            <div class="form-group">
              <label >Meaning in English</label>
              <textarea v-model="baby.meanings" :title="baby.meanings" type="text" class="form-control style-textarea" placeholder="meaning..." spellcheck="true" rows="2"></textarea>
            </div>
            <div class="form-group">
              <label>
                Status
              </label>
              <select v-model="baby.status"
                      class="form-control styleSelectElement" :disabled="disableStatus">
                <option :value="BabyNameStatuses.APPROVED">
                  {{BabyNameStatuses.APPROVED}}
                </option>
                <option :value="BabyNameStatuses.PENDING">
                  {{BabyNameStatuses.PENDING}}
                </option>
                <option :value="BabyNameStatuses.REJECTED">
                  {{BabyNameStatuses.REJECTED}}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import {getBabyDetails, updateBabyDetails} from "@/api/babynames";
import Multiselect from "vue-multiselect";
import {BabyNameStatuses} from "@/Utils/Constants/BabyNameStatuses";

export default {
  name: "EditBabyName",
  components: {Multiselect},
  data:function() {
    return {
      baby: {
        "id": 0,
        "name": "",
        "gender": "",
        "status": "",
      },
      disableStatus: false
    };
  },
  computed: {
    BabyNameStatuses() {
      return BabyNameStatuses
    },
    gender() {
      return this.baby.gender === 'M' ? 'Boy' : 'Girl'
    },
  },
  methods: {
    async load (id) {
      const babyDetails = await getBabyDetails(id).catch(ex => {
        this.showErrorMessage(ex)
      })
      this.baby = babyDetails.data.body
      this.baby.status === BabyNameStatuses.APPROVED ? this.disableStatus = true : this.disableStatus = false
      this.resetData();
      $("#baby_name_modal").modal("show");
    },
    async updateBabyDetails() {
      this.showLoading()
      const {data} = await updateBabyDetails(this.baby).catch(ex => {
        this.showErrorMessage(ex)
      })
      if (data.status === 200) {
        Swal.close();
        this.$parent.tableDraw();
        $("#baby_name_modal").modal("hide");
        this.resetData();
        swal("SUCCESS!", data.message, "success");
      } else {
        swal("Error!", data.message, "error");
      }
    },
    resetData: function () {
      this.rider = {
        "id": 0,
        "name": "",
        "gender": "",
        "status": "",
      };
    },
  }
}
</script>

<style scoped>
.style-textarea {
  resize: vertical;
  width: 100%;
  padding: 6px;
  height: 100px !important;
}
</style>